/* PITU'S PAWS — JS propio. Vanilla, sin librerias.
   Cada init comprueba si su elemento existe antes de actuar. */
(function () {
  "use strict";

  // Este archivo lo incluyen varias secciones; ejecutar el cuerpo una sola vez.
  if (window.__ppScripts) return;
  window.__ppScripts = true;

  // Marca que el JS propio arrancó: el CSS solo oculta los .pp-reveal si esta clase existe.
  document.documentElement.classList.add("pp-js");

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveal on scroll ---------- */
  function revealAll() {
    document.querySelectorAll(".pp-reveal").forEach(function (el) { el.classList.add("pp-visible"); });
  }
  function initReveal() {
    var els = document.querySelectorAll(".pp-reveal:not(.pp-visible)");
    if (!els.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) { revealAll(); return; }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("pp-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
    );
    els.forEach(function (el) { io.observe(el); });
    // Failsafe: nada puede quedarse invisible. A los 2 s se muestra lo que falte.
    setTimeout(revealAll, 2000);
    window.addEventListener("load", function () { setTimeout(revealAll, 400); });
  }

  /* ---------- Marquee: duplicar grupo dentro de la pista + fijar duracion ---------- */
  function initMarquees() {
    document.querySelectorAll("[data-pp-marquee]").forEach(function (wrap) {
      var track = wrap.querySelector(".pp-marquee__track");
      if (!track || track.dataset.ppReady) return;
      track.dataset.ppReady = "1";
      var group = track.querySelector(".pp-marquee__group");
      if (!group) return;
      var speed = parseFloat(wrap.dataset.ppSpeed || "40"); // px/s
      var clone = group.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
      requestAnimationFrame(function () {
        var dur = Math.max(10, group.scrollWidth / speed);
        track.style.animationDuration = dur + "s";
        track.dataset.ppReady = "1";
      });
    });
  }

  /* ---------- Reviews marquee (single track duplicated inline) ---------- */
  function initReviewsMarquee() {
    document.querySelectorAll("[data-pp-reviews]").forEach(function (vp) {
      var track = vp.querySelector(".pp-reviews__track");
      if (!track || track.dataset.ppReady) return;
      track.dataset.ppReady = "1";
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;
      items.forEach(function (it) {
        var c = it.cloneNode(true);
        c.setAttribute("aria-hidden", "true");
        track.appendChild(c);
      });
      var speed = parseFloat(vp.dataset.ppSpeed || "34");
      requestAnimationFrame(function () {
        var dur = Math.max(16, track.scrollWidth / 2 / speed);
        track.style.animationDuration = dur + "s";
        track.dataset.ppReady = "1";
      });
    });
  }

  /* ---------- FAQ: cerrar hermanos al abrir (details nativo) ---------- */
  function initFaq() {
    document.querySelectorAll("[data-pp-faq]").forEach(function (list) {
      if (list.dataset.ppReady) return;
      list.dataset.ppReady = "1";
      var items = list.querySelectorAll("details.pp-faq__item");
      items.forEach(function (d) {
        d.addEventListener("toggle", function () {
          if (d.open) {
            items.forEach(function (o) { if (o !== d) o.open = false; });
          }
        });
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initProductGallery() {
    var gal = document.querySelector("[data-pp-gallery]");
    if (!gal || gal.dataset.ppReady) return;
    gal.dataset.ppReady = "1";
    var mainImg = gal.querySelector(".pp-gallery__main img");
    var thumbs = gal.querySelectorAll(".pp-gallery__thumb");
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-full");
        if (full) {
          mainImg.src = full;
          mainImg.srcset = "";
        }
        thumbs.forEach(function (o) { o.setAttribute("aria-current", "false"); });
        t.setAttribute("aria-current", "true");
      });
    });
  }

  /* ---------- Product: colour swap + deal picker + colour-mix bundle ---------- */
  function initProductVariants() {
    var root = document.querySelector("[data-pp-product]");
    if (!root || root.dataset.ppReady) return;
    root.dataset.ppReady = "1";

    var moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";
    function money(cents) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    var colorMap = {};
    try { colorMap = JSON.parse(root.getAttribute("data-pp-colors") || "{}"); } catch (e) {}
    var colors = Object.keys(colorMap);

    var variants = [];
    var vEl = root.querySelector("[data-pp-variants]");
    if (vEl) { try { variants = JSON.parse(vEl.textContent); } catch (e) {} }

    var priceEl = root.querySelector("[data-pp-price]");
    var form = root.querySelector(".pp-buy__form");
    var idInput = form && form.querySelector('input[name="id"]');
    var atcBtn = root.querySelector("[data-pp-atc]");
    var atcText = atcBtn && atcBtn.querySelector("[data-pp-atc-text]");
    var dynWrap = root.querySelector("[data-pp-dynamic]");
    var qtyStepper = root.querySelector("[data-pp-qty]");
    var qtyNote = root.querySelector("[data-pp-qty-note]");
    var qtyInput = qtyStepper && qtyStepper.querySelector("input");
    var swatches = Array.prototype.slice.call(root.querySelectorAll(".pp-swatch"));
    var optLbl = root.querySelector("[data-pp-optval]");
    var dealsWrap = root.querySelector("[data-pp-deals]");
    var mixWrap = root.querySelector("[data-pp-mix]");
    var galleryImgs = document.querySelectorAll("[data-pp-gallery] .pp-gallery__thumb");
    var mainImg = document.querySelector("[data-pp-gallery] .pp-gallery__main img");

    var state = {
      qty: 1,
      color: (root.querySelector(".pp-swatch--active") || swatches[0] || {}).getAttribute
        ? (root.querySelector(".pp-swatch--active") || swatches[0]).getAttribute("data-value")
        : colors[0],
      mix: {},
    };

    function swapImage(color) {
      if (!mainImg || !variants.length) return;
      var vv = variants.find(function (x) { return x.option1 === color; });
      if (vv && vv.featured_image && vv.featured_image.src) {
        mainImg.src = vv.featured_image.src;
        mainImg.srcset = "";
        galleryImgs.forEach(function (t) {
          t.setAttribute("aria-current",
            t.getAttribute("data-media-id") === String(vv.featured_image.id) ? "true" : "false");
        });
      }
    }

    function renderMix() {
      if (!mixWrap) return;
      colors.forEach(function (c) {
        var el = mixWrap.querySelector('[data-mix-count="' + c + '"]');
        if (el) el.textContent = state.mix[c] || 0;
      });
      var tot = mixWrap.querySelector("[data-pp-mix-total]");
      var sum = colors.reduce(function (a, c) { return a + (state.mix[c] || 0); }, 0);
      if (tot) tot.textContent = "(" + sum + " / " + state.qty + ")";
    }

    function setDeal(btn) {
      if (dealsWrap) {
        dealsWrap.querySelectorAll(".pp-bundle").forEach(function (b) {
          b.classList.remove("pp-bundle--active");
          b.setAttribute("aria-pressed", "false");
        });
      }
      btn.classList.add("pp-bundle--active");
      btn.setAttribute("aria-pressed", "true");
      state.qty = parseInt(btn.getAttribute("data-qty"), 10) || 1;
      var total = parseInt(btn.getAttribute("data-total"), 10) || 0;
      var compare = parseInt(btn.getAttribute("data-compare"), 10) || 0;

      if (priceEl) {
        priceEl.innerHTML = compare > total
          ? "<s>" + money(compare) + "</s>" + money(total) +
            '<span class="pp-save">Save ' + money(compare - total) + "</span>"
          : money(total);
      }

      var bundle = state.qty > 1;
      if (mixWrap) mixWrap.hidden = !bundle;
      if (qtyStepper) qtyStepper.hidden = bundle;
      if (qtyNote) qtyNote.hidden = bundle;
      if (dynWrap) dynWrap.hidden = bundle;

      if (bundle) {
        state.mix = {};
        colors.forEach(function (c) { state.mix[c] = 0; });
        state.mix[state.color] = state.qty;
        renderMix();
        if (atcText) atcText.textContent = "Add " + state.qty + " to cart · " + money(total);
      } else {
        if (idInput && colorMap[state.color]) idInput.value = colorMap[state.color];
        if (qtyInput) qtyInput.value = 1;
        if (atcText) atcText.textContent = atcBtn.getAttribute("data-label-add") || "Add to cart";
      }
    }

    function adjustMix(color, delta) {
      if (colors.length !== 2) return;
      var other = colors[0] === color ? colors[1] : colors[0];
      var next = (state.mix[color] || 0) + delta;
      if (next < 0 || next > state.qty) return;
      state.mix[color] = next;
      state.mix[other] = state.qty - next;
      renderMix();
    }

    // colour swatches
    swatches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        swatches.forEach(function (o) {
          o.classList.remove("pp-swatch--active");
          o.setAttribute("aria-pressed", "false");
        });
        sw.classList.add("pp-swatch--active");
        sw.setAttribute("aria-pressed", "true");
        state.color = sw.getAttribute("data-value");
        if (optLbl) optLbl.textContent = state.color;
        swapImage(state.color);
        if (state.qty === 1) {
          if (idInput && colorMap[state.color]) idInput.value = colorMap[state.color];
        } else {
          state.mix = {};
          colors.forEach(function (c) { state.mix[c] = 0; });
          state.mix[state.color] = state.qty;
          renderMix();
        }
      });
    });

    // deal tiers
    if (dealsWrap) {
      dealsWrap.querySelectorAll(".pp-bundle").forEach(function (btn) {
        btn.addEventListener("click", function () { setDeal(btn); });
      });
    }

    // mix steppers
    if (mixWrap) {
      mixWrap.querySelectorAll("button[data-mix-step]").forEach(function (b) {
        b.addEventListener("click", function () {
          adjustMix(b.getAttribute("data-color"), b.getAttribute("data-mix-step") === "up" ? 1 : -1);
        });
      });
    }

    // add to cart — bundle path uses AJAX so colours can be mixed
    if (form) {
      form.addEventListener("submit", function (e) {
        if (state.qty <= 1) return; // normal single add
        e.preventDefault();
        var items = colors
          .filter(function (c) { return (state.mix[c] || 0) > 0 && colorMap[c]; })
          .map(function (c) { return { id: colorMap[c], quantity: state.mix[c] }; });
        if (!items.length) return;
        atcBtn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items }),
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            window.location.href = (window.routes && window.routes.cart_url) || "/cart";
          })
          .catch(function () {
            atcBtn.disabled = false;
            if (atcText) atcText.textContent = "Try again";
          });
      });
    }
  }

  /* ---------- Qty stepper (respects min / max) ---------- */
  function initQty() {
    document.querySelectorAll("[data-pp-qty]").forEach(function (q) {
      if (q.dataset.ppReady) return;
      q.dataset.ppReady = "1";
      var input = q.querySelector("input");
      if (!input) return;
      var min = parseInt(input.getAttribute("min"), 10) || 1;
      var max = parseInt(input.getAttribute("max"), 10) || Infinity;
      var btnDown = q.querySelector('[data-step="down"]');
      var btnUp = q.querySelector('[data-step="up"]');

      function clamp(n) { return Math.min(max, Math.max(min, n)); }
      function sync() {
        var val = clamp(parseInt(input.value, 10) || min);
        input.value = val;
        if (btnDown) btnDown.disabled = val <= min;
        if (btnUp) btnUp.disabled = val >= max;
      }

      q.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          var step = b.getAttribute("data-step") === "up" ? 1 : -1;
          input.value = clamp((parseInt(input.value, 10) || min) + step);
          sync();
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
      input.addEventListener("change", sync);
      input.addEventListener("blur", sync);
      sync();
    });
  }

  function boot() {
    window.__ppBooted = true;
    initReveal();
    initMarquees();
    initReviewsMarquee();
    initFaq();
    initProductGallery();
    initProductVariants();
    initQty();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Shopify theme editor: re-init when sections re-render
  document.addEventListener("shopify:section:load", boot);
})();
